import { useRef } from "react";

/*
 * Close a full-screen popup when the school clicks the dimmed backdrop around
 * the card. Spread the returned handlers on the overlay element.
 *
 * A click only counts when it both STARTS and ENDS on the backdrop itself: a
 * drag that begins inside the card (selecting text, a slipped tap on a button)
 * and is released over the backdrop must not throw the school out of the form.
 * Clicks inside the card bubble up with a different target and are ignored.
 */
export default function useBackdropClose(onClose) {
  const armed = useRef(false);
  return {
    onMouseDown: (e) => {
      armed.current = e.target === e.currentTarget;
    },
    onClick: (e) => {
      const hit = armed.current && e.target === e.currentTarget;
      armed.current = false;
      if (hit && typeof onClose === "function") onClose();
    },
  };
}
